module.exports = __webpack_public_path__ + "img/3.3402a684.png";